Math.easeInOutQuad = (time, start, change, duration) => {
  let currentTime = time / (duration / 2);
  if (currentTime < 1) return change / 2 * currentTime * currentTime + start;
  currentTime -= 1;
  return -change / 2 * (currentTime * (currentTime - 2) - 1) + start;
};

function scrollTo(element, to, duration) {
  const start = element.scrollTop;
  const change = to - start;
  let currentTime = 0;
  const increment = 20;

  const animateScroll = () => {
    currentTime += increment;
    const val = Math.easeInOutQuad(currentTime, start, change, duration);
    element.scrollTop = val;
    if (currentTime < duration) {
      setTimeout(animateScroll, increment);
    }
  };
  animateScroll();
}

function getElemPos(elem) {
  const body = document.documentElement || document.body;
  const header = document.querySelector('.c-header');
  const headerHeight = header ? header.clientHeight : 0;
  return elem.getBoundingClientRect().top + body.scrollTop - headerHeight - 8;
}

const scrollMixin = {
  methods: {
    // available direction: 'top' | 'bottom' | a DOM element | element position ( type number )
    scrollTo(direction = 'bottom') {
      const body = document.documentElement || document.body;
      if (direction instanceof HTMLElement) {
        scrollTo(body, getElemPos(direction), 1000);
      } else if (direction === 'bottom') {
        scrollTo(body, body.scrollHeight, 1000);
      } else if (direction === 'top') {
        scrollTo(body, 0, 1000);
      } else if (typeof direction === 'number') {
        scrollTo(body, direction, 1000);
      }
    },
  },
};
export default scrollMixin;
